<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-DeleteUser-Title" slot="header">{{ $t('userDeleteDialogTitle') }}</span>
    <i18n path="userDeleteDialogConfirmText" data-qa="Dialog-DeleteUser-ConfirmText" tag="span">
      <el-tag place="email" type="info">{{ email }}</el-tag>
    </i18n>
    <div slot="actions">
      <el-button
        :class="button.class"
        :data-qa="`Dialog-DeleteUser-Button-${button.id}`"
        :key="index"
        :type="button.type || 'warning'"
        @click.stop="button.click"
        v-for="(button, index) in buttons"
      >
        {{ $t(button.text) }}
      </el-button>
    </div>
  </hamv-dialog>
</template>

<script>
  import main from './UserDelete.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './UserDelete.scss'
</style>



// WEBPACK FOOTER //
// UserDelete.vue?54dac9ae